/**
 * @generated SignedSource<<c4caa915147740d8e39dfccc50e12b69>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type stripeConnectorPage_DisconnectMutation$variables = Record<PropertyKey, never>;
export type stripeConnectorPage_DisconnectMutation$data = {
  readonly stripeConnectionDisconnect: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly status: {
      readonly connected: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type stripeConnectorPage_DisconnectMutation = {
  response: stripeConnectorPage_DisconnectMutation$data;
  variables: stripeConnectorPage_DisconnectMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "connected",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "stripeConnectorPage_DisconnectMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StripeConnectionDisconnectMutationPayload",
        "kind": "LinkedField",
        "name": "stripeConnectionDisconnect",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeConnectionStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "stripeConnectorPage_DisconnectMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StripeConnectionDisconnectMutationPayload",
        "kind": "LinkedField",
        "name": "stripeConnectionDisconnect",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeConnectionStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "495c1be68065c32b6d9792c621de6865",
    "id": null,
    "metadata": {},
    "name": "stripeConnectorPage_DisconnectMutation",
    "operationKind": "mutation",
    "text": "mutation stripeConnectorPage_DisconnectMutation {\n  stripeConnectionDisconnect {\n    status {\n      connected\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7881a5bf8e79c76c26012da0d4c59c18";

export default node;
